export default class ImmunizationResult {
    constructor(immunizationName, immunizationType, immunizationDate, locationName) {
        this.immunizationName = immunizationName
        this.immunizationType = immunizationType
        this.immunizationDate = immunizationDate
        this.locationName = locationName
    }
}
